module.exports = __webpack_public_path__ + "static/media/menu_grupo_documento.f0dc10f5.png";